<div class="signature-page">
  <div class="info-row">
    <label>Nome cliente</label>
    <dx-text-box [(value)]="customerName" placeholder="Inserisci nome cliente"></dx-text-box>
  </div>

  <div class="pad-container">
    <canvas #canvas
            (touchstart)="startDrawing($event)"
            (touchmove)="moved($event)"
            class="signature-canvas"></canvas>
  </div>

  <div class="actions">
    <dx-button text="Pulisci" stylingMode="outlined" (onClick)="clearPad()"></dx-button>
    <!-- <dx-button text="Salva firma" type="success" (onClick)="savePad()"></dx-button> --> 
  </div>

  <!--
  <div *ngIf="signatureImg" class="preview">
    <h4>Anteprima</h4>
    <img [src]="signatureImg" alt="Firma" />
  </div>
  -->
</div>
